/**
 * AboutARAboutPageView
 *
 * Page component for AboutARAboutPageView
 * Path: /ar/about
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AboutARAboutPageView as __AboutARAboutPageView } from '@/components/traits/AboutARAboutPageView';
import { AboutARAboutAnalyticsView as __AboutARAboutAnalyticsView } from '@/components/traits/AboutARAboutAnalyticsView';
import { AboutARDemoChecksFetcherView as __AboutARDemoChecksFetcherView } from '@/components/traits/AboutARDemoChecksFetcherView';
import { AboutARDemoChecksDeskView as __AboutARDemoChecksDeskView } from '@/components/traits/AboutARDemoChecksDeskView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';
import { ToastSlot } from '@almadar/ui/components';

interface AboutARAboutPageViewProps {
  // Add any page-level props here
}

export function AboutARAboutPageView(_props: AboutARAboutPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-about:meta.title"],"description":["i18n/t","std-almadar-about:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/about"},{"locale":"ar","path":"/ar/about"},{"locale":"sl","path":"/sl/about"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AboutARAboutPageView config={{ initPayload: __navState }} />
          <__AboutARAboutAnalyticsView config={{ initPayload: __navState }} />
          <__AboutARDemoChecksFetcherView config={{ initPayload: __navState }} />
          <__AboutARDemoChecksDeskView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default AboutARAboutPageView;
